
import React from 'react';
import { Tooltip, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import uniqueId from 'lodash/uniqueId';

interface props {
  labelText: string;
  label: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  [key: string]: any;
}

export default (props: props) => {
  const { labelText, label, ...otherProps } = props;
  const labelWithButton = (
    <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {label}
      <Tooltip title={labelText} placement="right">
        <IconButton size="small" style={{ padding: '2px' }}>
          <HelpOutline fontSize="small" />
        </IconButton>
      </Tooltip>
    </span>
  );
  
  return (
    <FormControlLabel
      control={<Checkbox {...otherProps} />}
      label={labelWithButton}
    />
  );
};


